module.exports = __webpack_public_path__ + "media/images/lb/315-36dfec1a72a107c3b478818172f96c09.svg";